import Lib from '../../../commons/lib';

export default class Service {
  static ugyfelszolgalatUrl = window.location.origin + '/api/ugyfelszolgalat/';

  static helyszinUrl = window.location.origin + '/api/helyszin/';

  // ÜGYFÉLSZOLGÁLAT START
  static initBejelentesForm(fnDone) {
    Lib.MicroServices.requestService([{
      method: 'GET',
      url: Service.ugyfelszolgalatUrl + 'eset/initform',
      args: { requestType: 'eset-initform' }
    }], fnDone);
  }

  static initBejelentesFiltes(fnDone) {
    Lib.MicroServices.requestService([{
      method: 'GET',
      url: Service.ugyfelszolgalatUrl + 'eset/initfilter',
      args: { requestType: 'eset-initfilter' }
    }], fnDone);
  }

  static listBejelentes(all, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'PUT',
      url: Service.ugyfelszolgalatUrl + 'eset/list',
      args: { requestType: 'eset-list' },
      params: all
    }], fnDone);
  }

  static listBejelentesFilter(data, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'PUT',
      url: Service.ugyfelszolgalatUrl + 'eset/list',
      args: { requestType: 'eset-list' },
      data: data
    }], fnDone);
  }

  static addBejelentes(ugyfelszolgalat, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'POST',
      url: Service.ugyfelszolgalatUrl + 'eset',
      args: { requestType: 'eset-post' },
      data: ugyfelszolgalat
    }], fnDone);
  }

  static editBejelentes(ugyfelszolgalat, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'PUT',
      url: Service.ugyfelszolgalatUrl + 'eset',
      args: { requestType: 'eset-put' },
      data: ugyfelszolgalat,
    }], fnDone);
  }

  static editNaplo(ugyfelszolgalat, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'POST',
      url: Service.ugyfelszolgalatUrl + 'naplo',
      args: { requestType: 'naplo-post' },
      data: ugyfelszolgalat,
    }], fnDone);
  }

  static getBejelentes(id, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'GET',
      url: Service.ugyfelszolgalatUrl + 'eset',
      args: { requestType: 'eset-get' },
      params: { id: id }
    }], fnDone);
  }

  static deleteBejelentes(id, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'DELETE',
      url: Service.ugyfelszolgalatUrl + 'eset',
      args: { requestType: 'eset-delete' },
      params: { id: id }
    }], fnDone);
  }

  // static getHelyszin(fnDone) {
  //   Lib.MicroServices.requestService([{
  //     method: 'GET',
  //     url: Service.helyszinUrl + 'helyszin/gethelyszinbeanek',
  //     args: { requestType: 'helyszinUrl-gethelyszinbeanek' }
  //   }], fnDone);
  // }

  // ÜGYFÉLSZOLGÁLAT END
}
